import {useMamInformation} from "../../contexts/MamInformation";
import {useMamSummary} from "../../contexts/mamSummary";
import {useState} from "react";
import {useTheme} from "../../contexts/theme";
import {Box, Typography} from "@mui/material";
import {dividerClasses} from "@mui/material/Divider";
import TransparentButton from "../CommonComponents/TransparentButton/TransparentButton";
import Grid from "@mui/material/Grid";
import {formatUTCDate} from "../../utils/dateTimeutils";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import GroupClipContainer from "./GroupClipContainer";


interface EventMamProps {
    entity: any;
    onCollapseEventOpen: (competition: string, matchday: string, event_id: string, openEvent: boolean) => void;
    collapseOpen: boolean;
    loadingGroupClips: boolean;
}

export default function EventMam( {entity, onCollapseEventOpen, collapseOpen, loadingGroupClips}: EventMamProps) {

    const theme = useTheme();

    const {information} = useMamInformation();
    const {setInformation} = useMamInformation();

    const {summary} = useMamSummary();
    const {setSummary} = useMamSummary();


    const handleShowEvent = () => {
        onCollapseEventOpen(entity.championship, entity.matchday, entity.id, collapseOpen)
    }

    const typographyStyle = {
        fontWeight: theme.fontWeights.subParagraphTitle,
        minWidth: 80,
        color: theme.palette.white,
        marginLeft: theme.spacing.sm,
    }




    return (

                <Box width="100%" sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: theme.spacing.sm,
                    padding: `${theme.spacing.sm} ${theme.spacing.sm}`,
                }}>
                    <Box sx={{ display: 'flex'}}>
                        <Box display={'flex'} justifyContent={'space-between'} width={'100%'} sx={{paddingRight: theme.spacing.sm}} onClick={handleShowEvent}>
                                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} width={'100%'}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={4} justifyContent={'center'}>
                                                <Typography
                                                    variant="body1"
                                                    sx={typographyStyle}
                                                >
                                                    {entity.home_team +
                                                        "  " +
                                                        (entity.home_score !== undefined ? entity.home_score: "" ) +
                                                        " - " +
                                                        (entity.away_score !== undefined  ? entity.away_score : "") +
                                                        "  " +
                                                        entity.away_team +
                                                        (entity.game_number ? " - Game " + entity.game_number : "")
                                                    }
                                                </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Box display='flex' justifyContent='center' flexDirection={'column'} sx={{
                                                alignItems: 'center',
                                            }} >
                                                <Typography
                                                    variant="body1"
                                                    sx={typographyStyle}
                                                >
                                                    {"Event Start: "+formatUTCDate(entity.start_schedule, false)}
                                                </Typography>
                                            </Box>

                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <Box display='flex' justifyContent='center' flexDirection={'column'} sx={{
                                                alignItems: 'center',
                                            }} >

                                                <Typography
                                                    variant="body1"
                                                    sx={typographyStyle}
                                                >
                                                    {"Event End: " + formatUTCDate(entity.end_schedule, false)}
                                                </Typography>
                                            </Box>

                                        </Grid>
                                    </Grid>
                                    <Box display='flex' justifyContent='center' flexDirection={'column'} sx={{
                                        alignItems: 'end',
                                    }} >

                                        {collapseOpen ? <ArrowDropUpIcon/> : <ArrowDropDownIcon/>}
                                    </Box>
                                </Box>




                        </Box>
                    </Box>

                    {collapseOpen && (
                        <GroupClipContainer competition_id={entity.championship} event_id={entity.id} matchDay_id={entity.matchday} loadingGruopClips={loadingGroupClips}/>
                    )}

                </Box>

    );
}